module.exports = __webpack_public_path__ + "images/pipey_white.png";